export interface IHighlightedRows {
    sheetName: string;
    rows: number[];
    unmatchableAccountRows: number[];
}
